import { UnityData, HeaderContent } from "../../../LinkDataInterface";
import { mail, cartographe, github, wiki } from "./links";

const header: HeaderContent = {
  driveSearch: {
    url: "https://drive.google.com/drive/search?q=",
    color: "rgba(14, 68, 41, 0.47)",
    text: "rgb(239, 248, 248)",
  },
  logo: "https://2023.japan-impact.ch/img/logo.png",

  quickLinks: [mail, cartographe, github, wiki],
};

export const defaultJiData: UnityData = {
  name: "Japan Impact",
  style: {
    button: {
      color: "rgba(242, 254, 254, 0.9)",
      text: "#000000",
      hover: "rgba(58, 97, 70, 0.8)",
      textHover: "rgba(242, 254, 254)",
    },
    background: {
      imgLandscape: "https://2023.japan-impact.ch/img/poster2023.jpg",
      imgPortrait: "https://2023.japan-impact.ch/img/poster2023.jpg",
      color: "#dff4af",
    },
  },
  groups: [],
  header: header,
};
